module.exports = __webpack_public_path__ + "media/assets/faria_products/SB-LF-CORE-001-cb2ce4b161106ad35637f9c55b621d2daae04a0d69083dc14d7cd53f0d4f653c.png";